import { Outlet, createFileRoute } from "@tanstack/react-router";

// Layout route for /jobs/$slug — renders nested children (index, apply, status, submitted).
export const Route = createFileRoute("/jobs/$slug")({
  component: JobSlugLayout,
});

function JobSlugLayout() {
  return <Outlet />;
}
